import React from 'react';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
// import Weekend from "@material-ui/icons/Weekend";
import Home from "@material-ui/icons/Home";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import FormatQuote from "@material-ui/icons/FormatQuote";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Timeline from "components/Timeline/Timeline.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import Tasks from "components/Tasks/Tasks.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import StatsWrapper from '../../../components/Stats/StatsWrapper';

import {
    cardTitle,
    roseColor
} from "assets/jss/material-dashboard-pro-react.jsx";
import AccountManagerTotalsChart from './AccountManagerTotalsChart';
import AccountManagerTotalsTable from './AccountManagerTotalsTable';
import AllAccountsTotalGPChart from './AllAccountsTotalGPChart';
import AllAccountsTotalGPTable from './AllAccountsTotalGPTable';

const styles = {
    cardTitle,
    cardTitleWhite: {
        ...cardTitle,
        color: "#FFFFFF",
        marginTop: "0"
    },
    cardCategoryWhite: {
        margin: "0",
        color: "rgba(255, 255, 255, 0.8)",
        fontSize: ".875rem"
    },
    cardCategory: {
        color: "#999999",
        marginTop: "10px"
    },
    icon: {
        color: "#333333",
        margin: "10px auto 0",
        width: "130px",
        height: "130px",
        border: "1px solid #E5E5E5",
        borderRadius: "50%",
        lineHeight: "174px",
        "& svg": {
            width: "55px",
            height: "55px"
        },
        "& .fab,& .fas,& .far,& .fal,& .material-icons": {
            width: "55px",
            fontSize: "55px"
        }
    },
    iconRose: {
        color: roseColor
    },
    marginTop30: {
        marginTop: "30px"
    },
    testimonialIcon: {
        marginTop: "30px",
        "& svg": {
            width: "40px",
            height: "40px"
        }
    },
    cardTestimonialDescription: {
        fontStyle: "italic",
        color: "#999999"
    }
};


class Statistics extends React.Component {
    render() {
        
        const { classes } = this.props;

        return (
            <GridContainer justify='center'>
                <GridItem xs={12} sm={12} md={6}>
                    <Card>
                        <CardHeader color="warning" text>
                            <CardText color="warning">
                                <h4 className={classes.cardTitleWhite}>Account Managers</h4>
                                <h4 className={classes.cardCategoryWhite}>
                                    Gross Profit per Account Manager
                                </h4>
                            </CardText>
                        </CardHeader>
                        <CardBody>
                            <StatsWrapper snackbar={this.props.snackbar} name="accountManagerTotalGP" post>
                                <AccountManagerTotalsChart />
                                <AccountManagerTotalsTable />
                            </StatsWrapper>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Card>
                        <CardHeader color="info" text>
                            <CardText color="info">
                                <h4 className={classes.cardTitleWhite}>Top Accounts</h4>
                                <h4 className={classes.cardCategoryWhite}>
                                    Gross Profit for Top 10 Accounts
                                </h4>
                            </CardText>
                        </CardHeader>
                        <CardBody>
                            <StatsWrapper snackbar={this.props.snackbar} name="allAccountsTotalGp" post params={{ limit: 10 }}>
                                <AllAccountsTotalGPChart />
                                <AllAccountsTotalGPTable />
                            </StatsWrapper>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        );
    }
}

export default withStyles(styles)(Statistics);